import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { shippingMethodSelected } from '../../../actions/shop_shipping';
import { SHIPPING_METHOD, FREE_SHIPPING_THRESHOLD } from '../../../constants/shop/shop_constants';

import {
    FormControl, Typography, Alert, FormLabel,
    FormControlLabel, Radio, RadioGroup
} from "@mui/material";

const ShippingMethods = ({ display, fill }) => {
    const dispatch = useDispatch();
    const {
        cart: {
            item, // productos de carrito
            summary: { subtotal },
            coupon, // cupón aplicado
            checkout: { skip, order }
        },
        shipping: {
            methods: {
                full_list, client_list,
                selected: { _id, cost }, radio_button
            }
        }
    } = useSelector(state => state.shop);
    const odoo_id = order?.shipping?.odoo_id;
    
    useEffect(() => {
        const hasDiscountCoupon = Boolean(
            coupon?.name && coupon._class === 'order_discount'
        );
        if (item.length > 0) { // productos en carrito
            if (full_list.length > 0) { // al menos un método de envío disponible
                if (subtotal > FREE_SHIPPING_THRESHOLD && !hasDiscountCoupon) // tiene envío gratis
                   OrderFreeShipping();
                else {
                    if (coupon && coupon._class === 'free_shipping')
                        OrderFreeShipping();
                    else {
                        // quita el envío gratuito seleccionado (no tiene envío gratis)
                        if (_id && cost === 0)
                            dispatch(shippingMethodSelected({
                                selected: SHIPPING_METHOD,
                                radio_button: null
                            }));
                        // se redirige desde checkout rápido
                        else if (fill && skip && odoo_id) {
                            // elegir automáticamente método de envío seleccionado en pedido
                            const Method = full_list.find(e => e.odoo_id === odoo_id);
                            if (Method)
                                dispatch(shippingMethodSelected({
                                    selected: Method,
                                    radio_button: Method._id
                                }));
                        }
                        // lo deja si está seleccionado cualquier otro
                    }
                }
            } else
                dispatch(shippingMethodSelected({
                    selected: SHIPPING_METHOD,
                    radio_button: null
                }));
        } else
            dispatch(shippingMethodSelected({
                selected: SHIPPING_METHOD,
                radio_button: null
            }));
    }, [subtotal, coupon]);

    // useEffect(() => {
    //     if (client_list.length > 0) {
    //         // se redirige desde checkout rápido
    //         if (fill && skip) {
    //             // elegir automáticamente método de envío seleccionado en pedido
    //             const Method = full_list.find(e => e.odoo_id === odoo_id);
    //             if (Method)
    //                 dispatch(shippingMethodSelected({
    //                     selected: Method,
    //                     radio_button: null
    //                 }));
    //         }
    //     }
    // }, [client_list]);

    // pedido tiene envío gratis
    // (mínimo de compra o mediante cupón)
    const OrderFreeShipping = () => {
        const Method = full_list.find(e => e.cost === 0);
        if (Method)
            dispatch(shippingMethodSelected({
                selected: Method,
                radio_button: Method._id
            }));
        else
            dispatch(shippingMethodSelected({
                selected: SHIPPING_METHOD,
                radio_button: null
            }));
    };

    const onMethodSelect = ({ target }) => {
        const MethodSelected = full_list.find(e => e._id === target.value);
        if (MethodSelected)
            dispatch(shippingMethodSelected({
                selected: MethodSelected,
                radio_button: target.value
            }));
        else
            dispatch(shippingMethodSelected({
                selected: SHIPPING_METHOD,
                radio_button: null
            }));
    };

    return (
        display &&
        (
            client_list.length > 0 ?
                <FormControl>
                    <FormLabel id="shipping-radio-buttons-group-label">
                        Métodos de envío
                    </FormLabel>
                    <RadioGroup
                        aria-labelledby="shipping-radio-buttons-group-label"
                        value={ radio_button }
                        name="radio-group"
                        onChange={ onMethodSelect }>
                        {
                            client_list.map((e, i) =>
                                <FormControlLabel key={i}
                                    disabled={ false }
                                    value={ e._id }
                                    control={<Radio />}
                                    label={
                                        <Typography variant="body2">
                                            { e.partner } - ${e.cost} ({e.delivery_time})
                                        </Typography>
                                    }
                                />
                            )
                        }
                    </RadioGroup>
                </FormControl>
            :
                <Alert severity="info">No hay métodos de pago disponibles</Alert>
        )
    )
};

export default ShippingMethods;
